<template>
  <template v-if="['login', 'signup'].includes($route.name)">
    <router-view />
  </template>
  <TheAppLayout />
  <AppConfirmDialog />
  <!--<div v-show="!['login', 'signup'].includes($route.name)">
     <AppTopBar @logout="logout" />
    <WindowTray @minimize-window="minWindow" />
    <DockMenu :dialogs="window" />
    <TheAppLayout />
    <router-view />
    <Toast />
    <Toast position="bottom-center" group="custom">
      <template #message="slotProps">
        <div class="flex flex-column align-items-center" style="flex: 1">
          <div class="text-center">
            <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
            <div class="font-bold text-lg my-3">
              {{ slotProps.message.summary }}
            </div>
            <div class="my-3" v-html="slotProps.message.detail"></div>
          </div>
        </div>
      </template>
    </Toast>
    <ConfirmPopup />
  </div> -->
</template>

<script>
import AppConfirmDialog from './components/core/app-confirm-dialog.vue';

// import NotificationsService from './services/notifications.service';
// import { socket, sendMessage } from "./components/core/socket";
export default {
  components: { AppConfirmDialog },
  setup() {},
  data() {
    return {
      window: [],
    };
  },

  mounted() {
    // let notificationService = new NotificationsService();
    // notificationService.requestPermissions();
    window.scrollTo(0, 0);
  },
  created: function () {
    // socket.connect();
  },
  methods: {
    minWindow(data) {
      this.windows = data;
    },
  },
};
</script>

<style>
#app {
  font-family: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}
</style>
